import { Link } from "react-router-dom";
import { PawPrint } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/landing/Reveal";

export function SuccessHighlight() {
  return (
    <section className="bg-amtm-give/25 py-20 md:py-28" data-testid="landing-success-highlight">
      <div className="max-w-3xl mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <h2 className="font-display text-3xl md:text-4xl text-amtm-text mb-4">From broken to bounding.</h2>
          <p className="text-amtm-textMuted mb-8 max-w-xl mx-auto">
            Every month, animals leave our care healthy and whole. See the recoveries your support makes possible.
          </p>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="rounded-full h-[52px] px-8 border-amtm-text/20 font-semibold"
            data-testid="landing-read-success-stories-button"
          >
            <Link to="/success-stories">
              <PawPrint className="h-5 w-5 mr-2" /> Read Success Stories
            </Link>
          </Button>
        </Reveal>
      </div>
    </section>
  );
}
